import { Theme, useMediaQuery } from '@material-ui/core';
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints';

/**
 * Evaluates current breakpoint, or returns undefined if not yet available
 */
export function useGetBreakpoint():
  | 'mobile'
  | 'tablet'
  | 'desktop'
  | undefined {
  const isMobile = useIsMobile() && 'mobile';
  const isTablet = useIsTablet() && 'tablet';
  const isDesktop = useIsDesktop() && 'desktop';
  return isMobile || isTablet || isDesktop || undefined;
}

export function useIsMobile(): boolean {
  return useMediaQuery((theme: Theme) => theme.breakpoints.down('xs'), {
    noSsr: true,
  });
}

export function useIsTablet(): boolean {
  return useMediaQuery((theme: Theme) => theme.breakpoints.only('sm'), {
    noSsr: true,
  });
}

export function useIsDesktop(): boolean {
  return useMediaQuery((theme: Theme) => theme.breakpoints.up('md'), {
    noSsr: true,
  });
}

export function useScreenBetween(
  min: Breakpoint | number,
  max: Breakpoint | number,
): boolean {
  return useMediaQuery((theme: Theme) => theme.breakpoints.between(min, max), {
    noSsr: true,
  });
}

export function useScreenIsSmallerThan(size: number): boolean {
  return useMediaQuery((theme: Theme) => theme.breakpoints.down(size), {
    noSsr: true,
  });
}
